module.exports = __webpack_public_path__ + "static/media/app-stores.59f004ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app-stores.svg
// module id = 303
// module chunks = 25